import React from 'react';
import { IOrderItem } from './OrderDetails';
import { numberFormatter } from '../../utils/utilities';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { ADMIN_GROUPS } from '../../views/login/Login';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';

interface IMainTableRowProps extends IOrderItem {
	checkedItems: IOrderItem[];
	setCheckedItems: (items: IOrderItem[]) => void;
	currencySymbol: string;
}

export const MainTableRow = (props: IMainTableRowProps): JSX.Element => {
	const { checkedItems, setCheckedItems, currencySymbol, ...item } = props;
	const { quantity, name, referenceId, unitPrice, tax, discount, amount } = item;
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const isMerchantAdmin = authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.MERCHANT_ADMIN);

	const onCheckboxClick = (value: boolean): void => {
		let newCheckedItems = [...checkedItems];
		if (value) {
			newCheckedItems.push(item);
		} else {
			newCheckedItems = newCheckedItems?.filter(el => el.id !== item.id);
		}
		setCheckedItems(newCheckedItems);
	};

	return (
		<tr>
			{
				checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_SUPPORT_ADMIN)
					? (
						<td>
							<div className='form-check form-check-sm form-check-custom form-check-solid'>
								<input
									className='form-check-input'
									type='checkbox'
									checked={checkedItems.some((el: any) => el.id === item.id)}
									onChange={(e): void => onCheckboxClick(e.target.checked)}
								/>
							</div>
						</td>
					)
					: null
			}

			<td className="w-30px text-center fs-7">
				{quantity}
			</td>
			<td className="fs-7">
				{name}
			</td>
			<td className="w-90px fs-7">
				{referenceId}
			</td>
			<td className="w-90px fs-7 text-nowrap">
				{`${currencySymbol}${numberFormatter(unitPrice)}`}
			</td>
			<td className="w-70px fs-7 text-nowrap">
				{`${currencySymbol}${numberFormatter(discount)}`}
			</td>
			<td className="w-70px fs-7 text-nowrap">
				{`${currencySymbol}${numberFormatter(tax)}`}
			</td>
			<td className="w-70px fw-bolder fs-7 text-nowrap">
				{currencySymbol}{numberFormatter(amount)}
			</td>
		</tr>
	);
};
